(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faqImg-section"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.custom-faqAccord-accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const isOpen = content.style.display === 'block';

      document.querySelectorAll('.custom-faqAccord-accordion-content').forEach(item => item.style.display = 'none');

      content.style.display = isOpen ? 'none' : 'block';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-imageFaq-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('.custom-imageFaq-accordion-header');

    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        // Get the parent accordion element
        const accordion = this.parentElement;
        const content = this.nextElementSibling;
        const plusSign = this.querySelector('.custom-imageFaq-accordion-plus');

        // Check if this accordion is already active
        const isActive = accordion.classList.contains('active');

        // Close all accordions
        document.querySelectorAll('.custom-imageFaq-accordion').forEach(item => {
          item.classList.remove('active');
        });

        document.querySelectorAll('.custom-imageFaq-accordion-content').forEach(item => {
          item.style.display = 'none';
        });

        document.querySelectorAll('.custom-imageFaq-accordion-plus').forEach(plus => {
          plus.textContent = '+';
        });

        // If the clicked accordion wasn't active, open it
        if (!isActive) {
          accordion.classList.add('active');
          content.style.display = 'block';
          plusSign.textContent = '−';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const track = document.querySelector('.custom-reviews-track');
    const slides = document.querySelectorAll('.custom-reviews-slide');
    const prevButton = document.querySelector('.custom-reviews-prev');
    const nextButton = document.querySelector('.custom-reviews-next');
    const slider = document.querySelector('.custom-reviews-slider');
    
    if (!track || slides.length === 0) return;
    
    // Clone slides for infinite scrolling
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      track.appendChild(clone);
    });
    
    let slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(slides[0]).marginRight);
    let currentIndex = 0;
    let slidesPerView = getSlidesPerView();
    let isAnimating = false;
    
    // Touch variables
    let startX = 0;
    let endX = 0;
    let isDragging = false;
    let startTranslate = 0;
    
    // Set initial position
    updateTrackPosition();
    
    // Handle window resize
    window.addEventListener('resize', function() {
      slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(slides[0]).marginRight);
      slidesPerView = getSlidesPerView();
      updateTrackPosition();
    });
    
    // Navigation buttons
    prevButton.addEventListener('click', function() {
      if (isAnimating) return;
      navigateSlide(-1);
    });
    
    nextButton.addEventListener('click', function() {
      if (isAnimating) return;
      navigateSlide(1);
    });
    
    // Touch events for mobile swipe
    slider.addEventListener('touchstart', handleTouchStart, { passive: true });
    slider.addEventListener('touchmove', handleTouchMove, { passive: true });
    slider.addEventListener('touchend', handleTouchEnd);
    
    // Mouse events for desktop drag
    slider.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    
    // Auto scroll
    let autoScrollInterval = setInterval(function() {
      navigateSlide(1);
    }, 10000);
    
    // Pause auto scroll on hover or touch
    slider.addEventListener('mouseenter', function() {
      clearInterval(autoScrollInterval);
    });
    
    slider.addEventListener('mouseleave', function() {
      if (!isDragging) {
        autoScrollInterval = setInterval(function() {
          navigateSlide(1);
        }, 10000);
      }
    });
    
    function handleTouchStart(e) {
      if (isAnimating) return;
      clearInterval(autoScrollInterval);
      startX = e.touches[0].clientX;
      isDragging = true;
      startTranslate = getCurrentTranslate();
      track.style.transition = 'none';
    }
    
    function handleTouchMove(e) {
      if (!isDragging) return;
      endX = e.touches[0].clientX;
      const diff = endX - startX;
      track.style.transform = `translateX(${startTranslate + diff}px)`;
    }
    
    function handleTouchEnd() {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.5s ease';
      
      const diff = endX - startX;
      
      // Determine if swipe was significant enough to change slide
      if (Math.abs(diff) > slideWidth / 3) {
        if (diff > 0) {
          navigateSlide(-1);
        } else {
          navigateSlide(1);
        }
      } else {
        // Reset to current slide if swipe wasn't significant
        updateTrackPosition();
      }
      
      // Restart auto scroll after touch
      autoScrollInterval = setInterval(function() {
        navigateSlide(1);
      }, 10000);
    }
    
    function handleMouseDown(e) {
      if (isAnimating) return;
      e.preventDefault();
      clearInterval(autoScrollInterval);
      startX = e.clientX;
      isDragging = true;
      startTranslate = getCurrentTranslate();
      track.style.transition = 'none';
      slider.style.cursor = 'grabbing';
    }
    
    function handleMouseMove(e) {
      if (!isDragging) return;
      endX = e.clientX;
      const diff = endX - startX;
      track.style.transform = `translateX(${startTranslate + diff}px)`;
    }
    
    function handleMouseUp() {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.5s ease';
      slider.style.cursor = 'grab';
      
      const diff = endX - startX;
      
      // Determine if drag was significant enough to change slide
      if (Math.abs(diff) > slideWidth / 3) {
        if (diff > 0) {
          navigateSlide(-1);
        } else {
          navigateSlide(1);
        }
      } else {
        // Reset to current slide if drag wasn't significant
        updateTrackPosition();
      }
      
      // Restart auto scroll after drag
      autoScrollInterval = setInterval(function() {
        navigateSlide(1);
      }, 10000);
    }
    
    function getCurrentTranslate() {
      const style = window.getComputedStyle(track);
      const matrix = new WebKitCSSMatrix(style.transform);
      return matrix.m41;
    }
    
    function navigateSlide(direction) {
      isAnimating = true;
      currentIndex += direction;
      
      // Smooth transition
      track.style.transition = 'transform 0.5s ease';
      updateTrackPosition();
      
      // Reset position when reaching the end
      if (direction > 0 && currentIndex >= slides.length) {
        setTimeout(function() {
          track.style.transition = 'none';
          currentIndex = 0;
          updateTrackPosition();
          setTimeout(() => {
            track.style.transition = 'transform 0.5s ease';
            isAnimating = false;
          }, 50);
        }, 500);
      } 
      // Reset position when reaching the beginning
      else if (direction < 0 && currentIndex < 0) {
        setTimeout(function() {
          track.style.transition = 'none';
          currentIndex = slides.length - slidesPerView;
          updateTrackPosition();
          setTimeout(() => {
            track.style.transition = 'transform 0.5s ease';
            isAnimating = false;
          }, 50);
        }, 500);
      } else {
        setTimeout(() => {
          isAnimating = false;
        }, 500);
      }
    }
    
    function updateTrackPosition() {
      track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
    }
    
    function getSlidesPerView() {
      if (window.innerWidth < 992) {
        return 1;
      } else {
        return 2;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-timeline-section3"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Load AOS library if not already loaded
    if (typeof AOS === 'undefined') {
      var script = document.createElement('script');
      script.src = 'https://unpkg.com/aos@next/dist/aos.js';
      script.onload = initAOS;
      document.head.appendChild(script);

      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/aos@next/dist/aos.css';
      document.head.appendChild(link);
    } else {
      initAOS();
    }

    function initAOS() {
      AOS.init({
        duration: 800,
        once: true
      });
    }

    // Fallback animation if AOS doesn't load
    const timelineItems = document.querySelectorAll('.custom-timeline3-item');

    function checkIfInView() {
      timelineItems.forEach(item => {
        const rect = item.getBoundingClientRect();
        const isInViewport = (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.8 &&
          rect.bottom >= 0
        );

        if (isInViewport) {
          item.classList.add('visible');
        }
      });
    }

    window.addEventListener('scroll', checkIfInView);
    window.addEventListener('resize', checkIfInView);

    // Initial check
    setTimeout(checkIfInView, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
